export default __webpack_public_path__ + "static/media/onboarding-bg.3b5ed484.png";